import * as React from 'react';
import CurrencyQuery from '../../Query/Currencies';
import PriceInputControl, { IPriceInputControlProps } from './PriceInput';

class PricesWithDiscountInput extends React.Component<IPriceInputControlProps> {

  public render() {
    return (
      <CurrencyQuery>
        {({ currencies }: any) => {
          if (currencies && !currencies.loading && currencies.currencies) {
            return (
              <PriceInputControl
                {...this.props}
                currencies={currencies.currencies}
              />
            );
          }
          return null;
        }}
      </CurrencyQuery>
    );
  }
}

export default PricesWithDiscountInput;


// WEBPACK FOOTER //
// ./src/components/Others/PriceInput/index.tsx